<template>
	<div class="omapi-input__multiselect">
		<label v-if="label">{{ label }}</label>
		<multiselect
			ref="multiselect"
			v-bind="$attrs"
			:value="optionValue"
			:options="options"
			:multiple="multiple"
			:loading="loading"
			:placeholder="searchPlaceholder"
			:show-labels="false"
			open-direction="bottom"
			:label="optionsLabelField"
			track-by="value"
			:class="{
				'multiselect__has-value': hasValue,
				'multiselect__is-loading': loading,
				multiselect__nooptions: !options.length,
			}"
			@input="setValue"
			v-on="listenersExceptInput"
		>
			<template slot="option" slot-scope="props">
				<!-- eslint-disable-next-line vue/no-v-html -->
				<span v-html="props.option.fancyLabel || props.option.name"></span>
			</template>
			<template #placeholder>{{ placeholder }}</template>
			<template #clear>
				<div v-show="hasValue" class="omapi-input__multiselect-close-all" @click="clear">
					<img src="../../../assets/images/icons/card-close.svg" alt="Clear Select" />
				</div>
			</template>
			<template #noOptions><slot name="noOptions">List is empty.</slot></template>
			<template #afterList><slot name="afterList"></slot></template>
		</multiselect>
	</div>
</template>

<script>
import get from 'lodash/get';
import Multiselect from 'vue-multiselect';

export default {
	components: { Multiselect },
	inheritAttrs: false,
	props: {
		label: {
			type: String,
			default: '',
		},
		placeholder: {
			type: String,
			default: 'Type to search...',
		},
		searchPlaceholder: {
			type: String,
			default: '',
		},
		options: {
			type: Array,
			required: true,
		},
		multiple: {
			type: Boolean,
			default: false,
		},
		loading: {
			type: Boolean,
			default: false,
		},
		value: {
			type: [Array, String, Number, Object],
			default: '',
		},
		optionsLabelField: {
			type: String,
			default: 'name',
		},
	},
	computed: {
		optionValue() {
			const selected = this.value ? this.options.filter((o) => this.selected(o.value)) : [];

			return selected;
		},
		hasValue() {
			return this.optionValue.length;
		},
		listenersExceptInput() {
			if (this.$get('$listeners.input')) {
				const listeners = {};
				Object.keys(this.$listeners).forEach((type) => {
					if ('input' !== type) {
						listeners[type] = this.$listeners[type];
					}
				});
				return listeners;
			}

			return this.$listeners;
		},
	},
	methods: {
		selected(value) {
			const current = this.multiple ? this.value : this.$get('value.value', this.value);

			return this.multiple ? current.includes(value) : current === value;
		},
		setValue(selected) {
			selected = this.multiple ? selected.map((v) => v.value) : get(selected, 'value', selected || '');

			this.$emit('input', selected, this.$attrs);
		},
		clear() {
			this.$emit('input', this.multiple ? [] : '', this.$attrs);
		},
	},
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss">
.omapi-multi-select-input {
	text-align: left;
	margin-bottom: 10px;
}
</style>
